import { combineReducers } from "redux";
import commonReducer from './commonReducer'
import Constant from './constant'
export const reducers = combineReducers({
    commonReducer : commonReducer,
});


export const initialState = {
    commonReducer  :  commonReducer({...Constant.InitialData}, {type: "init"}),
}